import { Body1, H4 } from '../../../theme';
import { useFilter } from '../hooks';
import styled from 'styled-components6';

type FilterTitleProps = {
    title?: string;
};

const TitleContainer = styled(H4)`
    display: flex;
    flex-direction: row;
    margin-bottom: var(--rwl-spacing-md);
`;

const ClearButton = styled(Body1)`
    display: inline-block;
    color: var(--rwl-color-primary);
    cursor: pointer;
    margin-left: var(--rwl-spacing-md);
    align-self: center;
`;

export const FilterTitle = ({
    title = 'Filter',
}: FilterTitleProps): JSX.Element => {
    const { appliedFilters, clearAppliedFilters } = useFilter();
    return (
        <TitleContainer>
            {title}
            {appliedFilters?.length > 0 && (
                <ClearButton onClick={clearAppliedFilters}>
                    Clear All
                </ClearButton>
            )}
        </TitleContainer>
    );
};
